import { API } from "../store"

export const getOrganisationList = (pageNumber, pageSize = 20, keyword = '') => dispatch => {
    return new Promise((resolve, reject) => {
        API.get(`/org/organisation`)
            .query({ pageNumber: pageNumber })
            .query({ pageSize: pageSize })
            .query({ keyword: keyword })
            .then(res => {
                if (!res.ok) throw Error(res.statusText)
                return res.body
            })
            .then(data => {
                resolve(data)
            })
            .catch(err => reject(err))
    })
}

export const getBuyerList = (pageNumber, pageSize = 20, keyword = '') => dispatch => {
    return new Promise((resolve, reject) => {
        API.get(`/org/get-buyers-list`)
            .query({ pageNumber: pageNumber })
            .query({ pageSize: pageSize })
            .query({ keyword: keyword })
            .then(res => {
                if (!res.ok) throw Error(res.statusText)
                return res.body
            })
            .then(data => {
                resolve(data)
            })
            .catch(err => reject(err))
    })
}

export const addOrganisation = (data, organisationId, isEditMode) => dispatch => {
    return new Promise((resolve, reject) => {
        const method = isEditMode ? 'put' : 'post';
        let endPoint = "/org/organisation";
        if (isEditMode && organisationId) {
            endPoint += `/${organisationId}`
        }
        API[method](endPoint)
            .send(data)
            .then(res => res.body)
            .then(data => resolve(data))
            .catch(err => {
                reject(err.response.body);
            });
    });
};

export const getRealtorList = (pageNumber, pageSize = 20, keyword = '', isAdmin = false) => dispatch => {
    let apiPath = isAdmin ? '/get-realtor-list-admin' : '/get-realtor-list';
    return new Promise((resolve, reject) => {
        API.get(`/org${apiPath}`)
            .query({ pageNumber: pageNumber })
            .query({ pageSize: pageSize })
            .query({ keyword: keyword })
            .then(res => {
                if (!res.ok) throw Error(res.statusText)
                return res.body
            })
            .then(data => {
                resolve(data)
            })
            .catch(err => reject(err))
    })
}

export const getShowingsList = (id, keyword) => dispatch => {
    return new Promise((resolve, reject) => {
        API.get(`/org/get-showings-list/${id}`)
            .query({ keyword: keyword })
            .then(res => {
                if (!res.ok) throw Error(res.statusText)
                return res.body
            })
            .then(data => {
                resolve(data)
            })
            .catch(err => reject(err))
    })
}

export const handleUserStatus = (id, status, isOrg = false) => dispatch => {
    return new Promise((resolve, reject) => {
        API.put(`/org/${id}/${status}`)
            .query({ org: isOrg })
            .then(res => {
                if (!res.ok) throw Error(res.statusText)
                return res.body
            })
            .then(data => {
                resolve(data)
            })
            .catch(err => reject(err.response.body))
    })
}
